// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mhmX","top":"styles_top__ExrfE","left":"styles_left__2hQfK","description":"styles_description__3q2RQ"};